import { useCallback, useMemo, useState } from "react";
import { reimbursmentAction } from "@store/actions";
import { useDispatch } from "react-redux";
export function useExpenses(reimbursmentsList) {
  const dispatch = useDispatch();
  const [filtersLists, setFiltersLists] = useState({
    period: {
      startDate: null ,//moment().subtract(3, "month").toDate(),
      endDate: null, //moment().endOf("day").toDate(),
      timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    status: ""
  });

  const [filterLoading, setFilterLoading] = useState(false);
  const applyFilters = async (filters) => {
    const { period } = filters;
    await dispatch({
      type: "reimbursments/SET_EMPLOYER_FILTER",
      payload: {
        period: {
          startDate: period?.startDate,
          endDate: period?.endDate
        }
      }
    });
    await dispatch(reimbursmentAction.getByEmployer);
  };

  const reimbursmentsFiltered = useMemo(() => {
    const { status } = filtersLists;
    const newList = reimbursmentsList?.filter(
      (reimbursment) => status === "draft"
        ? reimbursment.status === "draft"
        : reimbursment.status !== "draft" && (!status || reimbursment.status === status)
    );
    setTimeout(() => {
      setFilterLoading(false);
    });
    
    if (!newList) return newList;

    const statusPriority = {
      waiting: 1,
      preApproved: 2,
      accepted: 3
    };
    
    return newList.sort((A, B) => {
      if (A.status in statusPriority && B.status in statusPriority) {
        return statusPriority[A.status] - statusPriority[B.status];
      }
      else if (A.status in statusPriority) {
        return -1;
      }
      else if (B.status in statusPriority) {
        return 1;
      }
      return 0;
    });
  }, [reimbursmentsList, filtersLists]);

  const drafts = useMemo(
    () => reimbursmentsList?.filter((reimbursment) => reimbursment.status === "draft") || [],
    [reimbursmentsList]
  );

  const getDataFilter = useCallback(
    async (filters, dateChanged) => {
      setFilterLoading(true);
      if (dateChanged) {
        await applyFilters(filters);
      }
      setFiltersLists(filters);
    },
    [dispatch]
  );

  return {
    getDataFilter,
    filterLoading,
    reimbursmentsFiltered,
    drafts,
    filtersLists
  };
}
